// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ux4uN","footer":"styles_footer__CJcpW"};